import { number, object } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';

import { SecondSpinOptions } from 'v2/types/SpecialDropSettingsModel';

export interface SpecialDropSettingsForm {
  minBalanceRewardAmount: number;
  maxBalanceRewardAmount: number;
  secondSpinOptions: SecondSpinOptions;
}

export const SECOND_SPIN_DESCRIPTION_MAX_LENGTH = 150;

export const validationSchema = object().shape({
  minBalanceRewardAmount: number().min(1000).required(YUP_ERRORS_MESSAGES.REQUIRED),
  maxBalanceRewardAmount: number().min(1000).required(YUP_ERRORS_MESSAGES.REQUIRED),
});
